import React from "react";
import "./Header.scss";

const Header = () => {
  return (
    <div className="header">
      <nav className="navbar navbar-expand-md navbar-dark">
        <div className="container">
          <button
            className="navbar-toggler collapsed"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false" // Ensure the navbar is collapsed initially
            aria-label="Toggle navigation"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar">
              <span className="middle-bar" />
            </span>
            {/* Default hamburger icon */}
          </button>
          <div className="navbar-left logo">
            <a
              target="_blank"
              href="https://www.dtf.wa.gov.au/"
            >
              <img src="/images/dtf-white-logo-rgb-landscape.svg" />
            </a>
          </div>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a
                  target="_blank"
                  id="make_claim_header_link"
                  href="https://www.wa.gov.au/service/business-support/business-accounting-and-reporting/unclaimed-money"
                >
                  Need help making a claim?
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
